<template>
  <div class="home">
    
    <div class="hero">
      <div class="main-title-wrapper">
        <LogoTitle :buttonText="'D'" />
      </div>

      <div class="main-skewband-wrapper">
        <SkewBand />
      </div>
      
      <div class="main-tentacles-wrapper">
        <img loading="lazy" :src="require('@/assets/img/tentaculob.png')" alt="">
      </div>

    </div>

    <MainTitle class="home-second-title" :titleText="'BIENVENIDO A'" :subTitleText="'Kraken Labs'" />

    <div class="title-krakenbuttons-wrapper">
      <span class="title-krakenbuttons-button-wrapper">
        <KrakenButton :buttonText="'S'" buttonLink="/services" />
        <span>Servicios</span>
      </span>
      <span class="title-krakenbuttons-button-wrapper">
        <KrakenButton :buttonText="'P'" buttonLink="#homeProjectsList" :isAnchor="true"/>
        <span>Proyectos</span>
      </span>
      <span class="title-krakenbuttons-button-wrapper">
        <KrakenButton :buttonText="'C'" buttonLink="/about" />
        <span>Conoce</span>
      </span>
      <span class="title-krakenbuttons-button-wrapper">
        <KrakenButton :buttonText="'C'" buttonLink="/contact" />
        <span>Contacta</span>
      </span>
    </div>

    <QuotesImage class="home-top-quote" :quoteText="'Desarrollos web ideados para entrar en la mente de tus clientes'" :quoteAuthor="'Kraken Labs'" :quoteImage="'brain.png'" />

    <ProjectsList id="homeProjectsList" class="home-project-list" />

    <!-- <QuotesImage class="home-mid-quote" :imgLast="true" :quoteText="'Lorem ipsum dolor sit amet consecuteur.'" :quoteAuthor="'Lorem Ipsum'" :quoteImage="'brain.png'" /> -->

    <div class="home-steps-wrapper">
      <GrowingBranches />
      <img loading="lazy" class="home-steps-img" :src="require('@/assets/img/mountains.png')" alt="">
      <div class="home-steps-testimonials">
        <Testimonials :testimonials="testimonials" />
      </div>
    </div>

    <ContactBanner />
    <Footer />

  </div>
</template>

<script lang="ts">
import { Component, Vue } from 'vue-property-decorator';
import KrakenButton from '@/components/buttons/Kraken-button.vue';
import SkewBand from '@/components/ui/SkewBand.vue';
import MainTitle from '@/components/texts/MainTitle.vue';
import LogoTitle from '@/components/texts/LogoTitle.vue';
import QuotesImage from '@/components/ui/QuotesImage.vue';
import ProjectsList from '@/components/interaction/ProjectsLists.vue';
import ContactBanner from '@/components/interaction/ContactBanner.vue';
import Testimonials from '@/components/ui/testimonials/Testimonials.vue';
import Footer from '@/components/parts/Footer.vue';
import GrowingBranches from '@/components/ui/GrowingBranches.vue';

import { testimonials } from '@/data/testimonials';

import { vw } from '@/utils/deviceDetect.ts';

import gsap, { Power3 } from 'gsap';
import ScrollTrigger from 'gsap/ScrollTrigger';

gsap.registerPlugin( ScrollTrigger );

@Component({
  components: {
    KrakenButton,
    SkewBand,
    MainTitle,
    QuotesImage,
    LogoTitle,
    ProjectsList,
    Testimonials,
    ContactBanner,
    GrowingBranches,
    Footer
  },
  data() {
    return {
      testimonials
    }
  }
  
})
export default class Home extends Vue {

  animateScrollMove() {
    this.animateTitle();
    this.animateTentacles();

    if( vw > 767 )
      this.animateGrowingBranches();

  }

  animateTentacles(){
    const tentacles = document.querySelector('.main-tentacles-wrapper') as HTMLDivElement;
    gsap.from( tentacles, {
      scrollTrigger: {
        trigger: tentacles,
        start: 'top 40%',
        end: 'bottom 40%',
        toggleActions: 'restart pause reverse pause',
        scrub: true
      },
      y: vw < 767 ? -300 : -50,
      opacity: 0,
      duration: 3,
      ease: 'none'
    });
  }

  animateTitle(){
    const title = document.querySelector('.home-second-title') as HTMLDivElement;
    gsap.from( title, {
      scrollTrigger: {
        trigger: title,
        start: 'top 100%',
        end: 'bottom 80%',
        toggleActions: 'restart pause reverse pause',
        scrub: true,
      },
      y: 100,
      duration: 3,
      ease: 'none'
    });
  }

  animateGrowingBranches() {
    const growingBranchesLogo    = document.querySelector('.growingbranches-img') as HTMLDivElement;
    const growingBranchesWrapper = document.querySelector('.growingbranches-wrapper') as HTMLDivElement;
    const growingBranchesElements = [...document.querySelectorAll('.growingbranches-step')] as HTMLDivElement[];
    const tl = gsap.timeline();

    tl.to( growingBranchesLogo, {
      scrollTrigger: {
        trigger: growingBranchesLogo,
        start: 'top 50%',
        end: 'bottom 15%',
        toggleActions: 'restart pause reverse pause',
        scrub: true,
      },
      scale: .3,
      duration: 1,
      ease: 'none'
    });

    tl.to( growingBranchesLogo, {
      scrollTrigger: {
        trigger: growingBranchesLogo,
        start: 'top 50%',
        endTrigger: growingBranchesWrapper,
        end: 'bottom 60%',
        toggleActions: 'restart pause reverse pause',
        scrub: true,
        pin: true
      },
      y: 100,
      opacity: 0,
      duration: 3,
      ease: 'none'
    });

    growingBranchesElements.forEach( elm => {
      gsap.to( elm, {
        scrollTrigger: {
          trigger: elm,
          start: 'top 60%',
          toggleActions: 'restart pause reverse pause',
        },
        opacity: 1,
        duration: 1,
        ease: Power3.easeOut
      });
    })
    
  }

  mounted() {
    setTimeout(() => {
      this.animateScrollMove();
    }, 1000);
  }

}
</script>

<style lang="scss">

  .home {
    &-top-quote,
    &-second-title, 
    &-top-quote ,
    &-project-list,
    &-mid-quote {
      padding-bottom: 15vh;
    }

    &-second-title {
      padding-bottom: 10vh;
    }

    @media SCREEN AND ( min-width: 768px ) {
      &-top-quote,
      &-second-title, 
      &-top-quote ,
      &-project-list,
      &-mid-quote {
        padding-bottom: 25vh;
      }
    }

    &-steps {

      &-img {
        position: absolute;
        bottom: 0%;
        left: 50%;
        transform: translateX(-50%) translateY(15%);
        -webkit-transform: translateX(-50%) translateY(15%);
        min-height: 100vmax;
      }

      &-wrapper {
        position: relative;
        min-height: 190vmax;
        overflow: hidden;
      }

      @media ( min-width: 1367px ) {
        &-img {
          min-height: 100vh;
        }

        &-wrapper {
          min-height: 190vh;
        }
      }

      &-testimonials {
        position: absolute;
        left: 0;
        bottom: 7.5vmin;
        width: 100%;
      }
    }
  }

  @keyframes decolor {
    0%, 
    100% {
      filter: grayscale(1) blur(1);
      -webkit-filter: grayscale(1) blur(1);
      background-position: 50% 50%;
    }
    50% {
      filter: grayscale(.65) blur(1);
      -webkit-filter: grayscale(.65) blur(1);
      background-position: 51% 51%;
    }
  }

  .hero {
    position: relative;
    height: 100vh;
    background: url(../assets/img/octopus.jpg);
    background-repeat: no-repeat;
    background-size: cover;
    margin-bottom: 70vh;
    position: relative;
    animation: decolor 6s infinite ease-in;
    transition: all .25s;

    &::after {
      content: '';
      position: absolute;
      width: 100%;
      height: 100%;
      background: #121315e3;
      left: 0;
      top: 0;
    }

    & .main {
      &-title {
        &-wrapper {
          display: flex;
          justify-content: center;
          align-items: flex-start;
          padding: 6vmax 6vmin 6vmax 0;
        }

        @media SCREEN AND ( min-width: 576px ) {
          &-wrapper {
            justify-content: flex-end;
            padding: 3vmax 9vmin;
          }
        }
      }
    }
  }

  .main {
      &-skewband {
        &-wrapper {
          position: absolute;
          left: 50%;
          top: 60vh;
          z-index: 3;
          width: 150vw;
          height: 50vh;
          max-height: 700px;
          transform: translate(-50%, 10%) rotateZ(-15deg);

        }
      }

      &-krakenbuttons {
        &-wrapper {
          display: flex;
          position: absolute;
          left: 50vw;
          top: 70vh;
          z-index: 4;
          width: 100%;
          justify-content: center;
          transform: translate(-50%, 10%) rotateZ(-20deg);

          & button {
            margin-right: 3.5rem;
            transform: rotateZ(20deg);
          }
        }
      }

      &-tentacles {
        &-wrapper {
          position: absolute;
          top: 115vh;
          left: 0;
          transform: rotateZ(-110deg);
        }

        @media SCREEN AND ( min-width: 576px ) {
          &-wrapper {
            left: 20vw;
          }
        }

        @media SCREEN AND ( min-width: 992px ) {
          &-wrapper {
            left: 50vw;
          }
        }
      }
  }

  .home {

    & .title-krakenbuttons {
      &-wrapper {
        max-width: 900px;
        margin: auto;
        display: flex;
        justify-content: space-evenly;
        margin-bottom: 20vmax;
        flex-direction: column;
        align-items: center;

        & .kraken-button {
          margin-bottom: 3rem;
        }

      }

      &-button {
        &-wrapper {
          text-align: center;
          color: #fff;
          position: relative;
          transition: all .25s;

          & > span {
            transition: all .25s;
            position: absolute;
            left: 50%;
            bottom: 1rem;
            font-size: 1.4rem;
            font-weight: 300;
            line-height: 1rem;
            letter-spacing: 1px;
            transform: translate(-50%, 0);
            -webkit-transform: translate(-50%, 0);
          }

          &:hover {
            color: rgb(230, 172, 49);
            & span {
              letter-spacing: 2px;
            }
          }
        }
      }
    }

    &-top-quote {
      cursor: grab;
    }

    @media SCREEN AND ( min-width: 576px ) {
      &-top-quote ,
      &-project-list,
      &-mid-quote {
        padding-bottom: 6rem;
      }

      &-top-quote {
        padding-bottom: 15vmax;
      }
      

      &-second-title {
        padding-bottom: 4rem;
      }

      & .title-krakenbuttons {
        &-wrapper {
          flex-direction: row;
          align-items: center;

          & .kraken-button {
            margin-bottom: 0;
          }
        }

        &-button {
          &-wrapper {
            text-align: center;
            color: #fff;
            position: relative;

            & > span {
              padding-top: 2rem;
              position: absolute;
              left: 50%;
              bottom: -2rem;
              font-size: 1.4rem;
              font-weight: 300;
              letter-spacing: 1px;
              line-height: 1rem;
              transform: translate(-50%, 0);
            }
          }
        }
      }
    }
    
  }


</style>
